import React, { useState } from "react";
import { useAuthStore } from "../stores/authStore";

export function LoginPage() {
  const login = useAuthStore((s) => s.login);
  const loading = useAuthStore((s) => s.loading);
  const error = useAuthStore((s) => s.error);
  const totpRequired = useAuthStore((s) => s.totpRequired);
  const clearError = useAuthStore((s) => s.clearError);
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    await login(password, totp || undefined);
  };

  return (
    <div className="page-center">
      <form className="card" onSubmit={handleSubmit}>
        <h1>Sign In</h1>
        <p>Enter your password to continue.</p>

        <div className="form-group">
          <label className="label" htmlFor="password">
            Password
          </label>
          <input
            id="password"
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </div>

        {totpRequired && (
          <div className="form-group">
            <label className="label" htmlFor="totp">
              Two-Factor Code
            </label>
            <input
              id="totp"
              className="input"
              type="text"
              inputMode="numeric"
              pattern="[0-9]{6}"
              maxLength={6}
              value={totp}
              onChange={(e) => setTotp(e.target.value)}
              autoFocus
              required
            />
          </div>
        )}

        {error && <p className="error-text">{error}</p>}

        <div className="form-actions">
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
